

var MatyTris = /** @class */ (function () {
    function MatyTris(elem) {
        this.isOpen = false;
        this.$wrapper = $(elem);
        this.$elemClick = $(elem).find('.custom-select');
        this.$list = $(elem).find('ul');

        this.addEvents();
    }
    MatyTris.prototype.onclick = function () {
        this.$wrapper.toggleClass("active");
    };
    MatyTris.prototype.addEvents = function () {
        var _this = this;

        this.$elemClick.click(function () {
            _this.onclick();
        });
    };
    return MatyTris;
}());

var PanelListeProduit = /** @class */ (function () {
    function PanelListeProduit(settings) {
        this.options = {
            'active-class': 'closed',
            multi: true
        };
        var _this = this;
        this.$wrapper = $(settings.wrapper);
        this.$buttons = $(settings.button);
        this.$overlay = $(settings.overlay);

        if (settings.options) {
            $.extend(_this.options, settings.options);
        }
        this.addEvents();
    }

    PanelListeProduit.prototype.openPanel = function () {
        var className = this.options["active-class"];

        this.$overlay.fadeIn();
        this.$wrapper.removeClass(className);
        $("html").addClass('disable-scroll');
    };

    PanelListeProduit.prototype.closePanel = function () {
        var className = this.options["active-class"];

        this.$overlay.fadeOut();
        this.$wrapper.addClass(className);
        $("html").removeClass('disable-scroll');
    };

    PanelListeProduit.prototype.addEvents = function () {
        var _this = this;

        this.$buttons.click(function () {
            _this.openPanel();
        });
        this.$overlay.click(function () {
            _this.closePanel();
        });
        this.$wrapper.find('.has-sub>.link').click(function () {
            _this.onclick($(this).parent(".has-sub"));
        });
        this.$wrapper.find('.close').click(function () {
            _this.closePanel();
        });
    };

    PanelListeProduit.prototype.onclick = function ($elem) {
        if (!this.options.multi) {
            $elem.siblings().addClass(this.options["active-class"]);

            if (!$elem.hasClass(this.options["active-class"])) {
                $elem.toggleClass(this.options["active-class"]);

                return;
            }
        }

        $elem.toggleClass(this.options["active-class"]);
    };

    return PanelListeProduit;
}());

$("#liste-produits-wrapper .hgroup p>a").click(function (event) {
    event.preventDefault();

    var id = $(this).attr("href");
    var top = $(id).offset().top;

    $("html, body").animate({ scrollTop: top }, 1200);
});

initHover();

// Gestion du bouton "Retour" du navigateur, qui doit recharger la page, comme si on cliquait sur une facette
window.addEventListener('popstate', function (event) {
    var urlContent = window.location.pathname;
    updateProductsList(urlContent, 1, false);
}, false);

$(document)
    .on('click', '.pseudo-link-products-list', function (event) {
        event.preventDefault();

        var target = $(event.currentTarget);
        var urlContent = target.data("href");
        var provider = target.data("provider");

        if (urlContent == null || urlContent.length == 0) {
            urlContent = target.attr("href");
        }
        else {
            urlContent = decodeURIComponent(atob(urlContent));
        }
        setFacetId(this);

        if (provider != undefined && provider === 'Sparkow') {
            if (urlContent != null && urlContent != '' && typeof (urlContent) != 'undefined' && urlContent != '') {
                if (!$('#filtres-wrapper').hasClass('closed')) {

                    updateFiltersList(urlContent);
                }
                else {

                    var urlEncoded = urlContent.replace(/[.]/g, '%2E');
                    updateProductsList(urlEncoded, 1, true);
                }
            }
        }

        // GA - click filtres
        var fcategory = target.data("fcategory");
        var fvalue = target.data("fvalue");

        if (fcategory != null && fcategory.length > 0 && fcategory != "") {
            var evt = {
                trigger: 'filtres',
                options: {
                    category: "filtres",
                    action: fcategory,
                    label: fvalue
                }
            };

            $(document).foundation('mastertag', 'track_tc_event', evt);
        }

    })
    .on("click", "[data-merchfilter]", function (event) {
        event.preventDefault();
        var filter = $(this).data("merchfilter");
        $('*[data-fvalue="' + filter + '"]').trigger("click");
    })
    .on('click', '.pseudo-link-products-list-global', function (event) {
        var urlContent = this.attributes["data-href"];
        var provider = this.attributes["data-provider"];

        setFacetId(this);

        if (provider != null && provider.value == 'Sparkow') {
            if (urlContent != null && urlContent != '' && typeof (urlContent) != 'undefined' && urlContent.value != '') {
                var urlDecode = $(this).hasClass("fbo2") ? decodeURIComponent(window.atob(urlContent.value)) : urlContent.value;
                updateProductsList(urlDecode, 2, true, true);
            }
        }
    })
    .on('click', '.pseudo-link-products-list-global-close-filters', function (event) {
        var urlContent = this.attributes["data-href"];

        setFacetId(this);

        if (urlContent != null && urlContent != '' && typeof (urlContent) != 'undefined' && urlContent.value != '') {
            var urlDecode = $(this).hasClass("fbo2") ? decodeURIComponent(window.atob(urlContent.value)) : urlContent.value;
            updateProductsList(urlDecode, 1, true);
        }
    })
    .on('click', '.pl-event', function (e) {
        var target = $(e.currentTarget);
        var reference = target.data("reference");

        if (typeof (tc_vars) !== "undefined" && typeof (tc_vars.list_products) !== "undefined") {
            var product = tc_vars.list_products.filter(function (p) {
                return p.product_id === reference;
            })[0];

            if (typeof (product) !== "undefined") {
                $(document).foundation('mastertag', 'track_tc_event', {
                    obj: "",
                    trigger: 'clic_liste_produit',
                    options: {
                        id: "clic_produit",
                        category: "plp",
                        action: product.product_name + '|' + product.product_id,
                        label: tc_vars.page_name,
                        value: product.product_unitprice_ati,
                        product_brand: product.product_trademark,
                        product_cat1: product.product_cat1,
                        product_cat2: product.product_cat2,
                        product_cat3: product.product_cat3,
                        product_category: product.product_category,
                        product_currency: product.product_currency,
                        product_discount_tf: product.product_discount_tf,
                        product_discount_ati: product.product_discount_ati,
                        product_gravable: product.product_gravable,
                        product_id: product.product_id,
                        product_name: product.product_name,
                        product_promo: product.product_promo,
                        product_promo_label: product.product_promo_label,
                        product_quantity: product.product_quantity,
                        product_rating: product.product_rating,
                        product_size: product.product_size,
                        product_trademark: product.product_trademark,
                        product_unitprice_ati: product.product_unitprice_ati,
                        product_unitprice_tf: product.product_unitprice_tf
                    }
                });
            }
        }
    });

function initProductsSlides() {
    if (window.matchMedia("(max-width:600px)").matches) {
        $('.produit-wrapper').each((index, item) => {
            const nbSlides = $(item).find('.swiper .swiper-slide').length;
            if (nbSlides > 1) {
                const slides = $(item).find(".swiper-slide");
                slides.each((i, slide) => {
                    $(slide).attr("src", $(slide).attr("data-src"));
                })
                const swiper = new Swiper(item.querySelector(".visuels-slider"), {
                    lazy: true,
                    loop: true,
                    crossFade: true,
                    effect: "fade",
                    pagination: {
                        el: ".swiper-pagination",
                        dynamicBullets: true,
                    },
                    on: {
                        transitionStart: (slider, event) => {
                            slider = slider.el;
                            const image = $(slider).find(".swiper-slide-active img");
                            if (image.attr("src").includes("data:image")) image.attr("src", image.attr("data-src"));
                        }
                    }
                });
            }
        })
    } else {
        $('.produit-wrapper').each((index, item) => {
            const nbSlides = $(item).find('.swiper .swiper-slide').length;
            if (nbSlides > 1) {
                const wrapper = item.querySelector(".swiper-wrapper");

                $(item).find(".visuel-wrapper").on('mouseenter', () => {
                    let indexImage = null;
                    const slides = $(item).find(".swiper-slide");

                    slides.each((index, slide) => {
                        const image = $(slide).find("img");
                        if (image.length > 0) {
                            const dataSrc = image.attr("data-src");

                            if (image.attr("src").includes("data:image")) image.attr("src", dataSrc)

                            if (dataSrc.includes("VP")) {
                                indexImage = index;
                            }
                        }
                    })

                    if (indexImage) {
                        const imageWidth = slides[indexImage].querySelector("img").clientWidth;
                        wrapper.scrollTo(indexImage * imageWidth, 0);
                    }
                })

                $(item).find(".visuel-wrapper").on("mouseleave", () => {
                    wrapper.scrollTo(0, 0);
                })
            }
        })
    }
}
initProductsSlides();
function setFacetId(e) {
    var facet_id = $(e).parent().closest('.niveau')[0];

    if (jQuery.type(facet_id) === "undefined") {
        //Cas zone filtre(s) déjà sélectionné(s)
    }
    else {
        if (jQuery.type(facet_id.id) === "undefined") {
            // ne devrait pas arriver
        }
        else {
            $('#facet_id_checked').val(facet_id.id);
        }
    }
};

initDisplay();
updateFilterDisplay();

function initHover() {
    $(".m-visuel").each(function () {
        let image = new ImageHover(".m-visuel", this);
    })
}

function initDisplay() {
    var filtresPanel = new PanelListeProduit({
        wrapper: "#filtres-wrapper",
        button: ".filtres-button",
        overlay: ".nav-overlay",
        options: {
            'active-class': 'closed',
            'multi': false
        }
    });
    var trisPanel = new PanelListeProduit({
        wrapper: "#tris-wrapper",
        button: ".tris-button",
        overlay: ".nav-overlay",
        options: {
            'active-class': 'closed'
        }
    });
    var tris = new MatyTris(".custom-select-wrapper");

    $('#button-afficher-nb-articles.subinfo').text('(' + $('#nb-articles-total').val() + ')');
}

function updateProductsList(urlForSparkow, closeFilters, isOnHistoryBack) {

    if (urlForSparkow[urlForSparkow.length - 1] == "/") {
        urlForSparkow = urlForSparkow.slice(0, -1);
    }
    $.ajax({
        url: '/Category/updateProductsList',
        data: { urlForSparkow: urlForSparkow, isGlobal: true },
        success: function (result) {
            if (history.pushState && isOnHistoryBack === true) {
                history.pushState({}, null, urlForSparkow);
            }

            var facet_id = $('#facet_id_checked').val();

            if (closeFilters == 0) {
                result._Filters = result._Filters.replace("closed", "");
            }
            updateProductsListDisplay(result);
            updateFilterDisplay(facet_id);
            $('#mobile-button-afficher').attr('data-href', urlForSparkow);
            Foundation.libs.common.hidePreloader();

            $('html, body').animate({ scrollTop: $("#liste-produits-wrapper").offset().top - 300 }, 800);

            if (closeFilters == 1) {
                $('.nav-overlay').fadeOut();
                $("html").removeClass('disable-scroll');
            }

            // Dispatch the event
            var event = new Event('productListUpdated');

            document.getElementById('main-content').dispatchEvent(event);

            if (result.seoInstructions != null) {
                updateSeo(result.seoInstructions);
            }
        },
        error: function () {
            Foundation.libs.common.hidePreloader();
        },
        beforeSend: function () {
            Foundation.libs.common.showPreloader();
        }
    });
};

function updateSeo(seoInstructions) {
    if (seoInstructions != null) {
        // Titre de la page
        document.title = seoInstructions.titleTag;

        // Meta robots
        if ($('meta[name="robots"]').length > 0) {
            if (seoInstructions.metaRobots != null && seoInstructions.metaRobots.length > 0) {
                console.log("set ROBOTS to " + seoInstructions.metaRobots);
                $('meta[name="robots"]').attr('content', seoInstructions.metaRobots);
            }
            else {
                $('meta[name="robots"]').remove();
            }
        }
        else {
            if (seoInstructions.metaRobots != null && seoInstructions.metaRobots.length > 0) {
                var meta = document.createElement('meta');
                meta.name = "robots";
                meta.content = seoInstructions.metaRobots;
                document.getElementsByTagName('head')[0].appendChild(meta);
            }
        }

        // Meta description
        if ($('meta[name="description"]').length > 0) {
            if (seoInstructions.metaDescription != null && seoInstructions.metaDescription.length > 0) {
                $('meta[name="description"]').attr('content', seoInstructions.metaDescription);
            }
            else {
                $('meta[name="description"]').remove();
            }
        }
        else {
            if (seoInstructions.metaDescription != null && seoInstructions.metaDescription.length > 0) {
                var meta = document.createElement('meta');
                meta.name = "description";
                meta.content = seoInstructions.metaDescription;

                document.getElementsByTagName('head')[0].appendChild(meta);
            }
        }
    }
}

function updateFiltersList(urlForSparkow) {
    var position = $('#filtres-wrapper > div').scrollTop();

    $.ajax({
        url: '/Category/updateProductsList',
        data: { urlForSparkow: urlForSparkow, isGlobal: false },
        success: function (result) {
            if (history.pushState) {
                history.pushState({}, null, urlForSparkow);
            }

            var facet_id = $('#facet_id_checked').val();

            result._Filters = result._Filters.replace("closed", "");
            updateFiltersListDisplay(result);
            updateFilterDisplay(facet_id);
            $('#mobile-button-afficher').attr('data-href', urlForSparkow);
            Foundation.libs.common.hidePreloader();
            $('#filtres-wrapper > div').scrollTop(position);
        },
        error: function () {
            Foundation.libs.common.hidePreloader();
        },
        beforeSend: function () {
            Foundation.libs.common.showPreloader();
        }
    });
};

function updateFiltersListDisplay(result) {

    this.updateComponent("_Filters", result._Filters, 0);
    this.updateMasterTagDataLayer(result);
    this.ForceScriptEncartJSToExecute();
    this.initBindings();
};

function updateFilterDisplay(facet_id) {
    var listFacets = $("#filtres-wrapper .menu .menu-navigation .niveau");

    if (jQuery.type(listFacets) === "undefined") {
        // Pas de filtres... Ne devrait pas arriver
    }
    else {
        if (jQuery.type(facet_id) === "undefined") {
            // le 1er filtre est ouvert, les autres fermés (ajout class 'closed')
            // Seuls les filtres avec un 'facet_id' sont concernés (la zone 'filtre(s) déjà selectionné(s)' devant être exclue par exemple)
            $.each($("#filtres-wrapper .menu .menu-navigation .niveau"), function (index, value) {
                if (value.id != "facet_0") {
                    $(value).addClass("closed");
                }
            });
        }
        else {
            // le filtre avec l'id facet_id est ovuert, les autres fermés
            // Seuls les filtres avec un 'facet_id' sont concernés (la zone 'filtre(s) déjà selectionné(s)' devant être exclue par exemple)
            $.each($("#filtres-wrapper .menu .menu-navigation .niveau"), function (index, value) {
                if (value.id != facet_id) {
                    $(value).addClass("closed");
                }
            });
        }
    }
};

function updateProductsListDisplay(result) {
    this.updateComponent("_GridHeader", result._GridHeader, 1);
    this.updateComponent("_Filters", result._Filters, 0);
    this.updateComponent("_SoldByMatySwitch", result._SoldByMatySwitch, 0);
    this.updateComponent("_Tri", result._Tri, 0);
    this.updateComponent("_MoreInfos", result._MoreInfos, 0);
    this.updateComponent("_HeaderListeProduits", result._HeaderListeProduits, 0);
    this.updateComponent("_ListeProduits", result._ListeProduits, 0);
    this.updateComponent("_Pagination", result._Pagination, 1);
    this.updateComponent("_TextSeo", result._TextSeo, 1);
    this.updateMasterTagDataLayer(result);
    this.initBindings();
    this.ForceScriptEncartJSToExecute();
    initGridPicturesSlider();
    //Reset Lazyload pour les encarts merch
    LazyLoad.reset();
    Foundation.libs.lazyloadvideos.reset()

    // Reset hover sur la photo produit
    initHover();

    initProductsSlides();

    Foundation.libs.common.initTrackMerch();    // Les actions de merch sont trackées. il faut réinitialiser ce traking à chaque refresh AJAX
}

function updateComponent(name, content, type) {
    var zone = this.selectComponent(name);
    if (type == 1) {
        zone.html(content);
    }
    else {
        zone.replaceWith(content);
    }
}

function selectComponent(name) {
    var elem;

    switch (name) {
        case "_GridHeader":
            elem = $("#grid-header-content");
            break;
        case "_Filters":
            elem = $("#filtres-wrapper");
            break;
        case "_Tri":
            elem = $("#tris-wrapper");
            break;
        case "_MoreInfos":
            elem = $("#more-infos");
            break;
        case "_HeaderListeProduits":
            elem = $("#header-liste-produits");
            break;
        case "_ListeProduits":
            elem = $("#produits");
            break;
        case "_Pagination":
            elem = $(".pagination-wrapper");
            break;
        case "_TextSeo":
            elem = $(".text-seo-content-wrapper");
            break;
        case "_SoldByMatySwitch":
            elem = $(".sold-by-maty");
            break;
        default:
            elem = null;
    }

    return elem;
}

function updateMasterTagDataLayer(result) {
    if (typeof (result) != "undefined" && typeof (result._MasterTagJson) != "undefined" && result._MasterTagJson.length > 0) {
        $(document).foundation('common', 'refreshMasterTagData', result._MasterTagJson);
        $(document).foundation('common', 'refreshMasterTag');
    }
}

function initBindings() {
    //Reset Lazyload pour les encarts merch
    LazyLoad.reset();
    Foundation.libs.lazyloadvideos.reset();
    initDisplay();
    initProductsSlides();
}

function ForceScriptEncartJSToExecute() {
    // Pour chaque balise script trouvée dans les encarts produit
    $("#produits .encart-wrapper script").each(function (index, element) {
        // Si on trouve du code JS dans la balise script
        if (element.innerHTML != '') {
            // on exécute le code JS
            eval(element.innerHTML);
        }
        else {
            // Si la baslise <script> possède un attribut "src ""
            if (typeof (element.src) != 'undefined') {
                // on recréé la même balise script
                var new_script = document.createElement('script');

                new_script.src = element.src;

                // on applique l'attribut async si on le trouve
                if (typeof (element.async) != 'undefined') {
                    new_script.async = element.async;
                }

                // on ajoute le "clone" de la balise script dans l'encart
                element.parentNode.appendChild(new_script);
            }
        }
    });
}

//# sourceMappingURL=main.js.map